<template>
    <div>
        <pagamento
            v-if="pagamento && pagamento.pagamentoId"
            :pagamento="pagamento"
            :pagamentosServicos="obterPagamentosServicos()"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
            v-show="mostrarPagamento"
        >
        </pagamento>
        <router-view></router-view>
    </div>
</template>

<script>
import PagamentosServicos from './PagamentosServicos'
import Pagamento from '@/app/gescon/pagamentos/Pagamento'

export default {
    data() {
        return {
            pagamento: {}
        }
    },

    methods: {
        obterPagamento() {
            this.$store.dispatch('addRequest')
            PagamentosServicos.obterPorId(this.$route.params.pagamentoId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.pagamento = response.data
                        } else {
                            this.$toast.error(
                                'Não foi possível obter o pagamento.',
                                'ERROR',
                                this.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            ).catch((error) => {
                console.error('Erro ao obter pagamento:', error)
                this.$toast.error('Erro ao carregar dados do pagamento.')
                this.$store.dispatch('removeRequest')
            })
        },

        obterPagamentosServicos() {
            return PagamentosServicos
        },

        obterPagamentoAtualizado() {
            this.obterPagamento()
        }
    },

    computed: {
        mostrarPagamento() {
            return this.$route.name == 'Gescon_Gerentes_Pagamentos_Detalhar'
        }
    },

    components: {
        Pagamento
    },

    created() {
        this.obterPagamento()
    }
}
</script>
